<template>
  <FKBreadCrumb :page="$t('page.create')" :title="$t('page.create_role')">
    <FKBreadCrumbItem :page="$t('page.roles')" to="/system-roles" />
  </FKBreadCrumb>
  <RoleForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import RoleForm from "@/components/FK/Roles/RoleForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";

export default defineComponent({
  name: "CreateRolePage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    RoleForm,
  },
});
</script>